"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREDIT_PROOF_PROTOCOL = exports.MAX_UINT256 = exports.BASE = exports.ONE_YEAR_IN_SECONDS = void 0;
var ethers_1 = require("ethers");
exports.ONE_YEAR_IN_SECONDS = ethers_1.BigNumber.from(31536000);
exports.BASE = ethers_1.BigNumber.from(10).pow(18);
exports.MAX_UINT256 = ethers_1.BigNumber.from(2).pow(255);
exports.CREDIT_PROOF_PROTOCOL = 'arcx.credit';
